import React from 'react';


const MetricCard = ({ title, value, unit, change, changeType, icon, iconColor, sparklineData }) => {
  const isPositive = changeType === 'positive';
  const isNegative = changeType === 'negative';
  const isNeutral = changeType === 'neutral';

  const renderSparkline = () => {
    if (!sparklineData || sparklineData?.length === 0) return null;

    const max = Math.max(...sparklineData);
    const min = Math.min(...sparklineData);
    const range = max - min || 1;

    const points = sparklineData?.map((value, index) => {
      const x = index / (sparklineData?.length - 1) * 100;
      const y = 100 - (value - min) / range * 100;
      return `${x},${y}`;
    })?.join(' ');

    return (
      <svg className="w-full h-12 mt-3" viewBox="0 0 100 100" preserveAspectRatio="none">
        <polyline
          points={points}
          fill="none"
          stroke={isPositive ? 'var(--color-success)' : isNegative ? 'var(--color-error)' : 'var(--color-primary)'}
          strokeWidth="2"
          vectorEffect="non-scaling-stroke" />

      </svg>);

  };

  return;








































};

export default MetricCard;